// Main getters
export const getters = {
  haveRunningTasks(state) {
    return state.runningTasks.length > 0
  },
  getUser(state) {
    return state.user;
  },
};
